import { useEffect, useRef, useState } from 'react';

// material-ui
import { alpha, useTheme } from '@mui/material/styles';
import AppBar from '@mui/material/AppBar';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import Popper from '@mui/material/Popper';
import Toolbar from '@mui/material/Toolbar';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

// project import
import Profile from './Profile';
import Transitions from '../../../../components/@extended/Transitions';
import { useThemeMode } from '../../../../themes/ThemeModeContext';

// assets
import MoreOutlined from '@ant-design/icons/MoreOutlined';
import DarkModeRoundedIcon from '@mui/icons-material/DarkModeRounded';
import LightModeRoundedIcon from '@mui/icons-material/LightModeRounded';

// ==============================|| HEADER CONTENT - MOBILE ||============================== //

export default function MobileSection() {
  const theme = useTheme();
  const { mode, toggleColorMode } = useThemeMode();

  const [open, setOpen] = useState(false);
  const anchorRef = useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  const prevOpen = useRef(open);
  useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  return (
    <>
      <Box sx={{ flexShrink: 0, ml: 0.25 }}>
        <IconButton
          sx={{
            color: 'text.primary',
            border: '1px solid',
            borderColor: 'divider',
            bgcolor: alpha(theme.palette.background.paper, open ? 0.94 : 0.72)
          }}
          aria-label="open more menu"
          ref={anchorRef}
          aria-controls={open ? 'menu-list-grow' : undefined}
          aria-haspopup="true"
          onClick={handleToggle}
        >
          <MoreOutlined />
        </IconButton>
      </Box>
      <Popper
        placement="bottom-end"
        open={open}
        anchorEl={anchorRef.current}
        role={undefined}
        transition
        disablePortal
        sx={{ width: 300, zIndex: 1301 }}
        popperOptions={{
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, 12]
              }
            }
          ]
        }}
      >
        {({ TransitionProps }) => (
          <Transitions type="fade" in={open} {...TransitionProps}>
            <Paper sx={{ boxShadow: theme.customShadows.z3, borderRadius: 3 }}>
              <ClickAwayListener onClickAway={handleClose}>
                <AppBar color="inherit" position="static" sx={{ borderRadius: 3, backgroundColor: 'background.paper' }}>
                  <Toolbar sx={{ display: 'block', p: 2 }}>
                    <Stack spacing={2}>
                      <Box
                        onClick={toggleColorMode}
                        sx={{
                          p: 1.5,
                          borderRadius: 3,
                          border: '1px solid',
                          borderColor: 'divider',
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                          cursor: 'pointer'
                        }}
                      >
                        <Box>
                          <Typography variant="subtitle2">Giao dien</Typography>
                          <Typography variant="body2" color="text.secondary">
                            {mode === 'dark' ? 'Dang o dark mode' : 'Dang o light mode'}
                          </Typography>
                        </Box>
                        {mode === 'dark' ? <LightModeRoundedIcon /> : <DarkModeRoundedIcon />}
                      </Box>
                      <Profile />
                    </Stack>
                  </Toolbar>
                </AppBar>
              </ClickAwayListener>
            </Paper>
          </Transitions>
        )}
      </Popper>
    </>
  );
}
